import { useCallback } from "react";
import { canv } from "@/canv/global";
import type { ActiveSubMenuState, SetActiveSubMenu } from "../../types";
import { SubMenu } from "../SubMenu/SubMenu";
import { AlignMenuContent } from "./AlignMenuContent";

interface AlignMenuProps {
    activeSubMenu: ActiveSubMenuState;
    setActiveSubMenu: SetActiveSubMenu;
}

export function AlignMenu({ activeSubMenu, setActiveSubMenu }: AlignMenuProps) {
    const handleButtonClick = useCallback(
        (align: string) => {
            canv.canvasController.alignSelected(align);
            setActiveSubMenu(null);
        },
        [setActiveSubMenu],
    );

    return (
        <SubMenu activeSubMenu={activeSubMenu}>
            <AlignMenuContent onClick={handleButtonClick} />
        </SubMenu>
    );
}
